
import axios from 'axios';
import Utils from '../utilities/utils';

const dispatcher = function () {


    /* Calls user required API 
       Also ensures session for the user(if session is unavailable in browser cookie) 
    */
    function callAPI(options) {
        return new Promise((resolve, reject) => {
            let session_key = Utils.getCookie('token_org')
            let uuid = Utils.getLocal('uuid')
            if (session_key) {
                options.headers = options.headers || {};
                options.headers["Authorization"] = session_key || "";
                options.headers["uuid"] = uuid || "";
            }

            axios({
                url: options.url,
                method: options.method || 'get',
                headers: options.headers,
                data: options.data || {},
                query: options.query || {},
                params: options.params || {},
                responseType: options.responseType || "json"
            })
                .then(response => {
                    resolve(response);
                })
                .catch((err, msg) => {
                    if (err.response) {
                        reject(err.response.data);
                    } else {
                        reject(err.message);
                    }
                    console.log('Error response in callAPI: ', err);
                })
        });
    }


    /*
     Default method to call an API with custom options
      This method invokes callAPI method after providing cookie availability in options
     */
    function call(options) {
        return new Promise((resolve, reject) => {
            callAPI(options).then(
                result => {
                    if (/^2\d\d$/ig.test(result.status)) {
                        resolve(result.data);
                    }
                    else
                        reject(result);
                })
                .catch(err => {
                    reject(err);
                    console.log('Error occurs in Call: ', err);
                })
        });
    }

    return {
        call
    }
}();

export default dispatcher;